const messages = {
  banksHeroHeading: 'banksHero.heading',
  banksHeroDescription: 'banksHero.description',
  banksListTotal: 'banks.total',
  banksRatingTooltip: 'banks.ratingTooltip',
  banksDepositAmountTitle: 'banks.depositAmountTitle',
  banksDepositAmountValue: 'banks.depositAmountValue',
  banksProtectionLimitTitle: 'banks.protectionLimitTitle',
  banksProtectionLimitValue: 'banks.protectionLimitValue',
  banksNoWithholdingTax: 'banks.noWithholdingTax',
  banksNoWithholdingTaxTooltip: 'banks.noWithholdingTaxTooltip',
  banksNoPaperwork: 'banks.noPaperwork',
  banksNoPaperworkTooltip: 'banks.noPaperworkTooltip',
  banksShariahTooltip: 'banks.shariahTooltip',
  banksShariah: 'banks.shariah',
  bankProductTypeChipTerm: 'bank.productTypeChip.term',
  bankProductTypeChipOvernight: 'bank.productTypeChip.overnight',
  bankProductTypeChipNotice: 'bank.productTypeChip.notice',
  bankOffersListItemRate: 'bank.offersListItem.rate',
  bankOffersListItemDuration: 'bank.offersListItem.duration',
  bankOffersListItemCurrency: 'bank.offersListItem.currency',
  bankOffersListItemProductType: 'bank.offersListItem.productType',
  bankOffersListItemCta: 'bank.offersListItem.cta',
  bankBestOfferTitle: 'bank.bestOffer.title',
  bankBestOfferButton: 'bank.bestOffer.button',
  promotedProductTermHeadline: 'promotedProduct.termHeadline',
  promotedProductNoticeHeadline: 'promotedProduct.noticeHeadline',
  promotedProductOvernightHeadline: 'promotedProduct.overnightHeadline',
  bankListPromotedProductHeadline: 'bank.banksList.promotedProduct.headlineText',
  bankListSortByLabel: 'bank.bankList.sortedByLabel',
  bankListSortAlphabetically: 'bank.bankList.sortAlphabetically',
  bankListSortByRating: 'bank.bankList.sortByRating',
  bankListItemNoCurrency: 'bank.bankListItem.noCurrency',
  bankListItemNoActiveProducts: 'bank.bankListItem.noActiveProducts',
};

export default messages;
